import React from "react";
import Table from "react-bootstrap/Table";
import search from "../../assests/search.svg";
import "./WarehouseComponent.css";

export const WarehouseComponent = ({ data, handleWarehouse, handleSearch }) => {
  return (
    <div className="warehouse-container">
      <div className="warehouse-search">
        <input
          type="search"
          placeholder="Search by Warehouse Name/ Warehouse ID"
          onChange={(e) => handleSearch(e.target.value)}
        />
        <img src={search} alt="Search" />
      </div>

      <div className="warehouse-table-container">
        <Table striped hover>
          <thead>
            <tr>
              <th>Warehouse ID</th>
              <th>Warehouse Name</th>
              <th>Area Name</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((el) => (
              <tr key={el.id}>
                <td>{el.warehouseId}</td>
                <td>{el.warehouseName}</td>
                <td>{el.warehouseCity}</td>
                <td>
                  <input 
                    type="radio" 
                    name="warehouse-radio" 
                    onChange={(e) => handleWarehouse(e, el.warehouseId)} 
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};